var _defs, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoNamecheapAlt = function SvgLogoNamecheapAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "272119%",
    y1: "53947.6168%",
    x2: "280114%",
    y2: "47120.1632%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3202c",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#db3c29",
    stopOpacity: 0.8,
    offset: "9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e35826",
    stopOpacity: 0.58,
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea7023",
    stopOpacity: 0.4,
    offset: "32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ef8421",
    stopOpacity: 0.26,
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4931f",
    stopOpacity: 0.14,
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f79e1e",
    stopOpacity: 0.06,
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8a41d",
    stopOpacity: 0.02,
    offset: "82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9a61d",
    stopOpacity: 0,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.33.5c-1.097 0-2.107.596-2.638 1.556l-.063.124-5.368 10.583 1.957 3.87.1.213a3.06 3.06 0 0 0 1.31 1.24c.55-.272 1.008-.704 1.3-1.24l.108-.213L32.078 4.75a3.02 3.02 0 0 0-.232-2.87c-.557-.855-1.5-1.38-2.52-1.37h.004zM11.16 6.134l-2.063-4.07C8.796 1.53 8.34 1.098 7.8.826a3.06 3.06 0 0 0-1.307 1.237l-.1.214L.343 14.17c-.647 1.477-.02 3.202 1.422 3.92s3.194.173 3.978-1.236L11.17 6.15l-.01-.016z",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.103 18.414c1.098-.001 2.108-.6 2.638-1.56l.062-.125 5.37-10.584-2.07-4.083c-.303-.535-.76-.967-1.3-1.24-.55.272-1.008.703-1.3 1.24l-.11.214L.34 14.17c-.413.935-.325 2.015.232 2.87s1.51 1.372 2.53 1.372z",
    fill: "url(#A)",
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.09
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.16 6.134l-2.063-4.07c-.303-.536-.76-.968-1.3-1.24A3.04 3.04 0 0 1 9.123.511h4.106c1.092.007 2.097.6 2.632 1.553l.11.214 5.3 10.512 2.062 4.07c.303.536.76.968 1.31 1.24a3.13 3.13 0 0 1-.577.214c-.25.065-.505.097-.762.096h-4.103c-1.092-.007-2.096-.6-2.632-1.552l-.11-.213-5.3-10.51z",
    fill: "#ddd"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoNamecheapAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-namecheap-alt.ab1c326a.svg";
export { ForwardRef as ReactComponent };